/* eslint-disable */
import React from 'react';

const FormField = {
    inputFieldMarkup: ({
        input, label, type, defaultValue = null, placeholder, meta: { touched, error },
    }) => {
        let errorClassName;
        const inputClassName = type === 'text' || 'tel' ? 'primary-input-field ' : ' ';

        if (touched && error) {
            errorClassName = 'has-error ';
        }
        return (
            <div className={`checkout-form-row ${errorClassName}`}>
                <label htmlFor={input.name} className="checkout-form-label">
                    {label}
                </label>
                <div className="checkout-form-fields">
                    <input {...input} {...(defaultValue !== null && {value: defaultValue})} className={inputClassName} placeholder={!placeholder ? label : placeholder} type={type} id={input.name}/>
                    {touched && error && <span className="help-block">{error}</span>}
                </div>
            </div>
        );
    },

    checkboxInputFieldMarkup: ({
        input, label, type, placeholder, defaultValue, meta: { touched, error }, extraClassName = '',
    }) => {
        let errorClassName;

        if (touched && error) {
            errorClassName = 'has-error ';
        }

        return (
            <div className={`checkout-form-row ${errorClassName} ${extraClassName}`}>
                <div className="checkout-form-fields">
                    <label htmlFor={input.name} className="checkout-form-label">
                        <input {...input} type={type} id={input.name} value={defaultValue} />
                        {' '}
                        {label}
                    </label>
                </div>
            </div>
        );
    },
};

export default FormField;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/shared/form-field.jsx
 **/